import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectToken, selectUser } from "../../features/auth/authSlice";

export default function ProtectedRoute() {
  const token = useSelector(selectToken);
  const user = useSelector(selectUser);
  const location = useLocation();

  if (!token) {
    // Redirect to login, keep the place they came from
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
